import React from "react";
import { connect } from "react-redux";
import MemberNotifications from "../components/MemberNotifications";

const NotificationsContainer = (props) => <MemberNotifications {...props} />;

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(NotificationsContainer);
